import {
  CardRender,
  CardRenderProps,
} from "@common/components";
import { useStatusTotal } from "@ca/orders/hooks/useStatusTotal";
import TotalWithoutResponse from "@ca/orders/components/StatusTotal/TotalWithoutResponse";
import TotalWithoutInvoice from "@ca/orders/components/StatusTotal/TotalWithoutInvoice";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useGridView } from "@common/context/GridView/useGridView";
interface FilterDates {
  begin_date: string,
  end_date: string
}

export default function StatusTotal() {
  let defaultFilterTop: FilterDates = {
    begin_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  }

  const [ filterTop, setFilterTop ] = useState<FilterDates>(defaultFilterTop);

  const { gridFilters } = useGridView();

  const total = useStatusTotal(filterTop);

  useEffect(() => {
    if (gridFilters !== undefined && gridFilters.length > 0) {
      let begin_date = gridFilters.find((gridFilter: any) => { return gridFilter.id === 'begin_date'})?.value
      let end_date = gridFilters.find((gridFilter: any) => { return gridFilter.id === 'end_date'})?.value

      if (begin_date !== undefined && end_date !== undefined) {
        begin_date = format(new Date(begin_date), 'yyyy-MM-dd');
        end_date = format(new Date(end_date), 'yyyy-MM-dd');
        defaultFilterTop = {
          begin_date,
          end_date
        }
  
        setFilterTop(defaultFilterTop)
      }
    }
  }, [gridFilters]);

  const propsInvoice: CardRenderProps = TotalWithoutInvoice({total : total.data ? total.data.totalizerWithoutInvoice : 0});
  const propsResponse: CardRenderProps = TotalWithoutResponse({total : total.data ? total.data.totalizerWithoutAnswer : 0});

  return (
    <div className="float-right md:flex mb-5">
      <CardRender {...propsInvoice} />

      <CardRender {...propsResponse} />
    </div>
  );
}
